var _style, _circle, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBadgeBtn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "AR",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 520 520",
    style: {
      enableBackground: "new 0 0 520 520"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#010101;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 260,
    cy: 260,
    r: 250
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M499.6,158.8c-19.7-46.7-52.7-86.4-94.2-114.4C363.9,16.4,313.8,0,260,0c-35.9,0-70.1,7.3-101.2,20.4 c-46.7,19.7-86.4,52.7-114.4,94.2S0,206.2,0,260c0,35.9,7.3,70.1,20.4,101.2c19.7,46.7,52.7,86.4,94.2,114.4S206.2,520,260,520 c35.9,0,70.1-7.3,101.2-20.4c46.7-19.7,86.4-52.7,114.4-94.2S520,313.8,520,260C520,224.1,512.7,189.9,499.6,158.8z M394.2,459 c-38.3,25.9-84.4,41-134.2,41c-33.2,0-64.7-6.7-93.4-18.9c-43.1-18.2-79.7-48.7-105.6-87C35.1,355.9,20,309.7,20,260 c0-33.2,6.7-64.7,18.9-93.4c18.2-43.1,48.7-79.7,87-105.6s84.4-41,134.2-41c33.2,0,64.7,6.7,93.4,18.9c43.1,18.2,79.7,48.7,105.6,87 s41,84.4,41,134.2c0,33.2-6.7,64.7-18.9,93.4C462.9,396.5,432.5,433.1,394.2,459z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M387,173.5L352.2,146c-2.2-1.7-4-4-5.2-6.5l-19.1-40c-3.7-7.8-12.3-11.9-20.7-10l-43.2,10c-2.7,0.6-5.6,0.6-8.3,0l-43.2-10 c-8.4-1.9-17,2.2-20.7,10l-19.1,40c-1.2,2.5-3,4.7-5.2,6.5L133,173.5c-6.7,5.3-8.9,14.6-5.1,22.4l19.4,39.8 c1.2,2.5,1.9,5.3,1.8,8.1l-0.2,44.3c0,8.6,5.9,16.1,14.3,17.9l29,6.5l-28.8,96.4l43.5-11.3l30.2,33.3l22.8-76.5l22.8,76.5 l30.2-33.3l43.5,11.3l-28.8-96.4l29-6.5c8.4-1.9,14.3-9.3,14.3-17.9l-0.2-44.3c0-2.8,0.6-5.6,1.8-8.1l19.4-39.8 C395.8,188.1,393.7,178.8,387,173.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M260,122.3c-51.4,0-93.1,41.7-93.1,93.1c0,51.4,41.7,93.1,93.1,93.1c51.4,0,93.1-41.7,93.1-93.1 C353.1,164,311.4,122.3,260,122.3z M317.7,273.2c-14.8,14.8-35.2,23.9-57.7,23.9c-22.6,0-42.9-9.1-57.7-23.9 c-14.8-14.8-23.9-35.2-23.9-57.7c0-22.6,9.1-42.9,23.9-57.7c14.8-14.8,35.2-23.9,57.7-23.9c22.6,0,42.9,9.1,57.7,23.9 c14.8,14.8,23.9,35.2,23.9,57.7C341.6,238,332.5,258.4,317.7,273.2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeBtn);
export default __webpack_public_path__ + "static/media/badge-btn.371d55ca7d8073a69617be226f9be007.svg";
export { ForwardRef as ReactComponent };